<template>

  <div v-if="showModal">
    <ModalComponent 
      :title_modal='title_modal'
      :text_modal='text_modal'
      :modal='modal'
    />
  </div>

  <div v-if="auth" class='if-auth'>
    <div v-if="load_page" class="gooey" >           
      <span class="dot"></span>
      <div class="dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div v-if='first_load' class='home' >
      <div class="navbar">
        <NavbarComponent 
          @active_menu='active_menu' 
        />
      </div>
      <div class="stream">
        <div class="player-layout">
          <StreamComponent 
            :key='update_stream_component'
            :stream_camera_selected='stream_camera'
            @end_playlist='end_playlist'
          />
        </div>
        <transition name="archive">
          <div v-if="opened_menu.archive" class="selections">
            <PeriodSelectComponent 
              :selected_period='selected_period'
            />
            <!-- <SliderTimeSelectComponent 
              :key='camera'
              :camera='camera'
              @selected_time_list='selected_time_list'
            /> -->
            <DownloadTimeSelectComponent 
              :selected_date='selected_date'
            />
          </div>
        </transition>
        <transition name="cameras_list_menu">
          <div v-if="opened_menu.cameras_list_menu" class="cameras-list-menu">
            <CamerasListMenuComponent
            :cameras_list='cameras_list'
            :new_positions='new_camera_menu_position'
            :stream_url='stream_url'
            />
          </div>
        </transition>
        <transition name="profile_menu">
          <div v-if="opened_menu.profile_menu" class="profile-menu">
            <ProfileMenuComponent 
              @map_updated='map_updated' 
              @modal_message='modal_message'
              @add_camera='add_camera'
              :camera_added='camera_added'
            />
          </div>
        </transition>
        <transition name="camera">
          <div v-if="opened_menu.camera" class="camera-update-menu">
            <CameraUpdateMenuComponent
              :key='update_stream_component'
              :camera_update='stream_camera'
              @submit_camera='submit_camera'
              />
          </div>
        </transition>
      </div>
      <div class="cameras">
        <CamerasListComponent 
          :cameras_list='cameras_list'
          :stream_url='stream_url'
          @active_button='active_button' 
          @modal_message='modal_message'
        />       
      </div>

      <div class="map-location" v-if="map_location">
        <MapLocationComponent
          :map_location='map_location'
          :cameras_list='cameras_list'
          :stream_url='stream_url'
          :new_camera_position_in_map='new_camera_position_in_map'
        />        
      </div>

      <footer class="footer">
        <div class="text footer-text">
          Copyright © 2016-2021 OLLI GROUP
        </div>
        
      </footer>
    </div>

  </div>
</template>

<script>

  import CamerasListComponent from '../components/CamerasList'
  import StreamComponent from '../components/Stream'
  import PeriodSelectComponent from '../components/PeriodSelect'
  import SliderTimeSelectComponent from '../components/SliderTimeSelect'
  import DownloadTimeSelectComponent from '../components/DownloadTimeSelect'
  import NavbarComponent from '../components/Navbar'
  import CamerasListMenuComponent from '../components/CamerasListMenu'
  import ProfileMenuComponent from '../components/ProfileMenu'
  import CameraUpdateMenuComponent from '../components/CameraUpdateMenu'
  import ModalComponent from '../components/Modal'
  import MapLocationComponent from '../components/MapLocation'

  import axios from "axios";

  export default {
    
    name: 'home',

    components: {
      CamerasListComponent, StreamComponent, PeriodSelectComponent, SliderTimeSelectComponent, DownloadTimeSelectComponent, 
      NavbarComponent, CamerasListMenuComponent, ProfileMenuComponent, CameraUpdateMenuComponent, ModalComponent, MapLocationComponent
    },

    data() {
      return {
        ge_sid: sessionStorage.getItem('ge_sid'),
        headers: {'Content-Type':'application/json', 'Authorization':'Token ' + sessionStorage.getItem('auth_token')},
        // url: 'http://127.0.0.1:8000/',
        url: '/api/',
        cameras_list: {},
        stream_camera: {},
        camera: '',
        first_load: false,
        update_stream_component: 0,
        opened_menu: {
          archive:false,
          cameras_list_menu:false,
          profile_menu: false,
          camera: false
        },
        opened_buttons: {
          location: false,
          four_list: false,
          six_list:false,
        },
        map_location: '',

        title_modal: '',
        text_modal: '',
        showModal: false,
        error: '',
        camera_added: false,

      };
    },

    created() {
      this.get_start()
      this.session_timer()
      sessionStorage.removeItem('cameras_list')
      sessionStorage.removeItem('columns')
    },

    computed: {
      auth() {
        if (sessionStorage.getItem('auth_token')) {
          return true
        }
        else {
          this.$router.push({ name: 'Login' });
        }
      },
    },
    methods: {
      get_start (){
        this.load_page = true
        axios({
          method: "post",
          url: this.url + "cameraslist",
          data: {'ge_sid': this.ge_sid},
          headers: this.headers,
        })
        .then((response) => {
          console.log(response)
          this.cameras_list = response.data.cameras_detail
          this.camera = response.data.cameras_detail[0]
          this.stream_camera['camera'] =  this.camera
          this.stream_camera['play_list'] = []
          this.stream_camera['camera_uid'] = ''
          this.first_load = true
          this.load_page = false
        })
        .catch((error) => {
          if (error.response.data == 'session_expired') {
            this.title_modal = 'Помилка сесiї'
            this.text_modal = 'Сесiя закiнчилась, увiйдiть ще раз.'
            this.error = 'session_expired'
            this.showModal = !this.showModal 
          }
         
        })
      },

      end_playlist(data) { 
        let body = {
          'ge_sid':this.ge_sid,
          'last_time':data.last_time,
          'camera_uid':data.camera_uid
        }
        axios({
          method: "post",
          url: this.url + "camera-play-list",
          data: body,
          headers: this.headers,
        })
        .then((response) => {
          this.stream_camera['play_list'] = response.data.playlist
          this.update_stream_component += 1
        })
        .catch((error) => {
          if (error.response.data == 'session_expired') {
            this.title_modal = 'Помилка сесiї'
            this.text_modal = 'Сесiя закiнчилась, увiйдiть ще раз.'
            this.error = 'session_expired'
            this.showModal = !this.showModal 
          }
        })
      },

      stream_url(data) {
        this.stream_camera['camera'] = data.value
        this.stream_camera['play_list'] = []
        this.stream_camera['camera_uid'] = ''
        for (let val in this.cameras_list) {
          if (this.stream_camera.camera.name === this.cameras_list[val].name) {
            this.camera = this.cameras_list[val]
          }          
        }
        this.update_stream_component += 1

      },

      selected_time_list(data) {
        this.stream_camera['play_list'] = data.selected_list
        this.update_stream_component += 1
      },
    
      selected_period(data){
        if (data.set_period === "0") {
          this.stream_camera['play_list'] = []
          this.update_stream_component += 1
        } 
        else {
          let camera_uid = ''
          for (let val in this.cameras_list) {
            if (this.stream_camera.camera.camera_code === this.cameras_list[val].camera_code) {
              this.stream_camera['camera_uid'] = this.cameras_list[val].camera_code
              camera_uid = this.cameras_list[val].camera_code
            } 
          }
          
          let body = {
            'ge_sid':this.ge_sid,
            'period':data.set_period,
            'camera_uid':camera_uid
          }
          axios({
            method: "post",
            url: this.url +  "camera-play-list",
            data: body,
            headers: this.headers,
          })
          .then((response) => {
            this.stream_camera['play_list'] = response.data.playlist
            this.update_stream_component += 1
          })
          .catch((error) => {
            if (error.response.data == 'session_expired') {
            this.title_modal = 'Помилка сесiї'
            this.text_modal = 'Сесiя закiнчилась, увiйдiть ще раз.'
            this.error = 'session_expired'
            this.showModal = !this.showModal
            }
          })
        }
      },

      selected_date(data) {
        let date = Date.parse(data.date + ' ' + data.time)
        let date_now = Date.now()
        if (date > date_now || isNaN(date)) {
          this.title_modal = 'Помилка'
          this.text_modal = 'Дата не коректна.'
          this.error = 'error'
          this.showModal = !this.showModal
        }
        else {
          
          let body = {
            'ge_sid': this.ge_sid,
            'date_selected': date,
            'camera_uid':this.stream_camera.camera.camera_code
          }
          axios({
            method: "post",
            url: this.url + "camera-play-list",
            data: body,
            headers: this.headers,
          })
          .then((response) => {
            if (data.type == 'find') {
              this.stream_camera['play_list'] = response.data.playlist
              this.update_stream_component += 1
            }
            else {
              axios({
                url: response.data.playlist[0],
                method: 'GET',
                responseType: 'blob', // important
              }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'video.mp4');
                document.body.appendChild(link);
                link.click();
              });         
            }
          })
          .catch((error) => {
            if (error.response.data == 'session_expired') {
              this.title_modal = 'Помилка сесiї'
              this.text_modal = 'Сесiя закiнчилась, увiйдiть ще раз.'
              this.error = 'session_expired'
              this.showModal = !this.showModal
            }
            else if (error.response.data == 'error_date') {
              this.title_modal = 'Помилка'
              this.text_modal = 'Дата не коректна.'
              this.error = 'error'
              this.showModal = !this.showModal
            }
          })
        }
      },

      submit_camera(data) {
         axios({
            method: "post",
            url: this.url + "camera-update",
            data: data,
            headers: this.headers,
          })
          .then((response) => {
            this.stream_camera.camera.camera_info[0].name = data.name
            this.stream_camera.camera.camera_info[0].info = data.info
            this.stream_camera.camera.camera_info[0].geoaddr = data.geoaddr
            this.title_modal = 'Успiх'
            this.text_modal = 'Новi данi збереженi.'
            this.error = 'success'
            this.showModal = !this.showModal
          })
          .catch((error) => {
            this.title_modal = 'Помилка'
            this.text_modal = 'Не коректно введенi данi.'
            this.error = 'error'
            this.showModal = !this.showModal
          })
      },

      active_menu(data) {
        for (let a in this.opened_menu) {
          this.opened_menu[a] = false
        }
        for (let a in this.opened_menu) {
          if (a == data.menu) {
            this.opened_menu[a] = true
          }
        }
      },

      get_map(data) {
        axios({
          method: "post",
          url: this.url + "map",
          data: data,
          headers: this.headers,
        })
        .then((response) => {
          this.map_location = response.data.map
        })
        .catch((error) => {
          this.title_modal = 'Помилка'
          this.text_modal = 'Карта не завантажена.'
          this.error = 'error'
          this.showModal = !this.showModal
        })
      },

      active_button(data) {
        if (data.menu == 'location') {
          this.get_map(data)
        }
        else {
          this.map_location = ''
        }
      },

      map_updated(data) {
        if (data.status = 'update') {
          let menu = {}
          menu['menu'] = 'location'
          this.get_map(menu)
        }
      },

      new_camera_menu_position(data){
        axios({
          method: "post",
          url: this.url + "camera-update-position",
          data: data,
          headers: this.headers,
        })
        .then((response) => {            
        })
        .catch((error) => {
          console.log(error)
          this.title_modal = 'Помилка'
          this.text_modal = 'Помилка збереження, спробуйте ще раз.'
          this.error = 'error'
          this.showModal = !this.showModal
        })
      },

      new_camera_position_in_map(data) {
        axios({
          method: "post",
          url: this.url + "map-points",
          data: data,
          headers: this.headers,
        })
        .then((response) => {    
          for (let camera in this.cameras_list) {
            if (this.cameras_list[camera].camera_code == data.camera_code) {
              this.cameras_list[camera].camera_info[0].map_position_x = data.map_position_x
              this.cameras_list[camera].camera_info[0].map_position_y = data.map_position_y
            }
          }
        })
        .catch((error) => {
          console.log(error)
          this.title_modal = 'Помилка'
          this.text_modal = 'Помилка збереження, спробуйте ще раз.'
          this.error = 'error'
          this.showModal = !this.showModal
        })
      },

      add_camera(data) {
        axios({
          method: "post",
          url: this.url + "camera-add",
          data: data,
          headers: this.headers,
        })
        .then((response) => {    
          this.cameras_list.push(response.data)
          this.camera_added = true       
        })
        .then(() => {
          setTimeout(this.camera_added = false, 4000)
        })
        .catch((error) => {
          this.title_modal = 'Помилка'
          if (error.response.data == 'uuid_not_in_list') {
            this.text_modal = 'Невiрно введений uid.'
          } else {
            this.text_modal = 'Камера з таким uid вже iснує.'
          }
          this.error = 'error'
          this.showModal = !this.showModal
        })
      },

      modal() {
        if (this.error == 'session_expired') {
          if (this.showModal == true) {
            this.$router.push({ name: 'Login' })
          }
        } 
        else {
          this.showModal = !this.showModal
        }
      },

      modal_message(data) {
        this.title_modal = data.title_modal
        this.text_modal = data.text_modal
        this.error = 'error'
        this.showModal = !this.showModal
      },

      session_timer() {
        let self = this
        setTimeout(function(){
          self.title_modal = 'Помилка сесiї'
          self.text_modal = 'Сесiя закiнчилась, увiйдiть ще раз.'
          self.error = 'session_expired'
          console.log('session')
          self.showModal = !self.showModal
        }, 1800000)
      }
    }

  }
</script>

<style scoped>

@import '../assets/styles/load-page.css';

.camera-enter-active,
.profile_menu-enter-active,
.archive-enter-active, 
.cameras_list_menu-enter-active {
  -webkit-transition: all 0.3s 0.3s ease;
  -moz-transition: all 0.3s 0.3s ease;
  -o-transition: all 0.3s 0.3s ease;
  transition: all 0.3s 0.3s ease;
}

.camera-leave-active,
.profile_menu-leave-active,
.archive-leave-active, 
.cameras_list_menu-leave-active {
  -webkit-transition: step-end;
  -moz-transition: step-end;
  -o-transition: step-end;
  transition: step-end;

}

.camera-enter-from,
.camera-leave-to,
.profile_menu-enter-from,
.profile_menu-leave-to,
.archive-enter-from,
.archive-leave-to,
.cameras_list_menu-enter-from,
.cameras_list_menu-leave-to
{
  transform: translateX(30px);
  opacity: 0;
}


.if-auth {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%) 
}

.home {
  height: 100vh;
  max-width: 1200px;
  display: grid;
  grid-template-rows: 0.1fr 1fr 2fr auto auto;
  grid-auto-flow: row;
}

.selections {
  margin-top: 23px;
  margin-right: 50px;
  display: grid;
  grid-template-columns: 1fr;
  width: 265px;
  justify-items: center;
  justify-self: center;
  border-radius: 5px;
}

.cameras-list-menu {
  margin-top: 23px;
  margin-right: 50px;
  width: 265px;
  display: grid;
  justify-items: center;
  justify-self: center;
  grid-template-rows: 45px 1fr;
}

.camera-update-menu {
  margin-top: 23px;
  margin-right: 50px;
  width: 265px;
  display: grid;
  justify-items: left;
  justify-self: center;
}

.profile-menu {
  margin-top: 23px;
  margin-right: 50px;
  width: 265px;
  display: grid;
  justify-items: center;
  justify-self: center;
}


.stream {
  display: grid;
  grid-template-columns: 1fr auto;
  margin-bottom: 30px;
}

.map-location {
  position: relative;
  display: grid;
  grid-template-rows: 1fr;
  margin-top:20px;
  margin-bottom: 20px;
}


.footer {
  background: #C0D72D;
  height: 31px;
  text-align: center;
  align-self: end;
}

.footer-text {
  margin-top: 10px;
  color: rgb(63, 63, 63);
}

@media (max-width: 1025px) {
   .home {
    margin-top: 60px;
  }
}


@media (max-width: 850px) {

  .home {
    margin-top: 80px;
  }
  
  .stream {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }

  .selections {
    width: 60%;
    margin-right: 0;
  }

  .cameras-list-menu {
    margin-right: 0;
  }

  .profile-menu {
    margin-right: 0;
  }

  .camera-update-menu {
    margin-right: 0;
  }

}

@media (max-width: 600px) {
  .home {
    margin-top: 50px;
    grid-template-rows: 0.1fr 0.1fr 0.1fr 0.5fr auto;
  }

  .selections {
    width: 80%;
    margin-right: 0;
  }

  .footer-text {
    font-size: 14px;
  }

}


</style>


